<h2 mat-dialog-title>Payment proofs</h2>

<mat-dialog-content>
  <p class="hint">
    {{ data.settlement.supplier_name }} · {{ data.settlement.amount | number }} Toman · {{ data.settlement.status }}
  </p>

  @if (loading) {
  <div class="center"><mat-spinner diameter="28"></mat-spinner></div>
  } @else if (error) {
  <div class="center err">{{ error }}</div>
  } @else {
  @if (proofs.length === 0) {
  <p class="empty">No proof attached yet.</p>
  } @else {
  <div class="grid">
    @for (p of proofs; track p.id; let i = $index) {
    <div class="tile">
      @if (p.url) {
      <img [src]="p.url" [alt]="'Proof ' + (i + 1)" (click)="view(p)" matTooltip="Open">
      } @else if (p.error) {
      <div class="placeholder"><mat-icon>broken_image</mat-icon></div>
      } @else {
      <div class="placeholder"><mat-spinner diameter="20"></mat-spinner></div>
      }
      <div class="meta">
        <span>#{{ i + 1 }} · {{ p.created_at | date:'short' }}</span>
        @if (!data.readOnly) {
        <button mat-icon-button type="button" matTooltip="Remove" [disabled]="busy" (click)="remove(p)">
          <mat-icon>delete</mat-icon>
        </button>
        }
      </div>
    </div>
    }
  </div>
  }

  @if (!data.readOnly) {
  <div class="add-row">
    <button mat-stroked-button type="button" [disabled]="busy || room === 0" (click)="fileInput.click()">
      <mat-icon>add_photo_alternate</mat-icon> Add proofs
    </button>
    <input #fileInput type="file" [accept]="accept" multiple hidden (change)="onFilesSelected($event)">
    <span class="count">{{ proofs.length }} / {{ maxProofs }}</span>
    @if (busy) { <mat-spinner diameter="18"></mat-spinner> }
  </div>
  }
  @if (fileError) { <p class="file-error">{{ fileError }}</p> }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Close</button>
</mat-dialog-actions>
